import Inputmask from "inputmask";
Inputmask.extendDefinitions({ A: { validator: '[1-9]' } })

document.addEventListener('DOMContentLoaded', () => {
  const phoneInputmask = new Inputmask({
    mask: '(A99) 999 99 99',
    clearIncomplete: true,
  });
  phoneInputmask.mask('.js-inputmask-phone');

  const mobilePhoneInputmask = new Inputmask({
    mask: '(599) 999 99 99',
  });
  mobilePhoneInputmask.mask('.js-inputmask-mobile-phone');

  const postalCodeInputmask = new Inputmask({
    mask: '9{5}',
    clearIncomplete: true,
  });
  postalCodeInputmask.mask('.js-inputmask-postal-code');

  const creditCardInputmask = new Inputmask({
    mask: '9{4} 9{4} 9{4} 9{4}',
  });
  creditCardInputmask.mask('.js-inputmask-credit-card');

  const cvvInputmask = new Inputmask({
    mask: '999[9]',
    clearIncomplete: true
  });
  cvvInputmask.mask('.js-inputmask-cvv');

  const dateInputmask = new Inputmask({
    alias: 'datetime',
    inputFormat: 'dd/mm/yyyy',
    clearIncomplete: true,
  });
  dateInputmask.mask('.js-inputmask-date');

  const heightInputmask = new Inputmask({
    mask: 'A9[9]',
    jitMasking: true,
  });
  heightInputmask.mask('.js-inputmask-height');

  const tcknInputmask = new Inputmask({
    mask: '9{11}',
    clearIncomplete: true,
  });
  tcknInputmask.mask('.js-inputmask-tckn');

  const verificationCodeInputMask = new Inputmask({
    mask: 'a{2}9{3}',
    clearIncomplete: true,
    oncomplete: () => {
      if (document.activeElement.classList.contains('js-inputmask-verification-code')) {
        document.activeElement.value = document.activeElement.value.toUpperCase();
      }
    }
  });
  verificationCodeInputMask.mask('.js-inputmask-verification-code');
});